import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from 'react-i18next';

export const LESSON_SUMMARY_MAX_LENGTH = 600;

const trimToLimit = value => Array.from(value).slice(0, LESSON_SUMMARY_MAX_LENGTH).join("");

const LessonSummaryPanel = ({ value, canEdit, onChange, onShowHistory, onSave, saveDisabled, saving, saved }) => {
  const { t: tr } = useTranslation();
  return (<section className="attendance-page__lesson-summary" aria-labelledby="lesson-summary-title">
    <div className="attendance-page__lesson-summary-heading">
      <h2 id="lesson-summary-title">{tr("manage:lessonTopicAndSummary_244")}</h2>
      <button type="button" className="btn manage-button manage-teal-button" onClick={onShowHistory}>{tr("manage:previousTopics_245")}</button>
    </div>
    <label htmlFor="lesson-summary" className="sr-only">{tr("manage:lessonTopicAndSummary_244")}</label>
    <textarea
      id="lesson-summary"
      className="form-control"
      rows="1"
      value={value}
      disabled={!canEdit}
      placeholder={tr("manage:brieflyDescribeWhatTheLessonCoveredAndWhatThe_246")}
      onChange={event => onChange(trimToLimit(event.target.value))}
    />
    <div className="attendance-page__lesson-summary-meta">
      {onSave && (
        <button type="button" className="btn manage-button manage-red-button" disabled={saveDisabled} onClick={onSave}>
          {saving ? tr("manage:extraSavingTopic_60") : tr("manage:extraSaveTopic_61")}
        </button>
      )}
      {saved && <span role="status">{tr("manage:topicSaved_247")}</span>}
      <span className="attendance-page__lesson-summary-count">{Array.from(value).length}/{LESSON_SUMMARY_MAX_LENGTH}</span>
    </div>
  </section>);
};

LessonSummaryPanel.propTypes = {
  value: PropTypes.string,
  canEdit: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onShowHistory: PropTypes.func.isRequired,
  onSave: PropTypes.func,
  saveDisabled: PropTypes.bool,
  saving: PropTypes.bool,
  saved: PropTypes.bool,
};

LessonSummaryPanel.defaultProps = { value: "", onSave: null, saveDisabled: true, saving: false, saved: false };

export default LessonSummaryPanel;
